// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

// NOTE: This is the rich UI PaymentMethod object (code, nameKey, icons, ...).
// Do not confuse it with the simple payment-method code string exported by
// @tectonics/commons/payment-methods/payment-method.ts.
import {type Node} from 'react';
import type { Country } from '@tectonics/commons/country';
import {SUPPORTED_COUNTRIES} from '@tectonics/commons/country';
import type { Country as CountryCode } from '@tectonics/prs/country';
import type { OutgoingPaymentMapper } from '@tectonics/prs/outgoing-payment/mapper';

export type PaymentMethod = {|
  code: string,
  nameKey: string,
  placeOrderMessageKey: string,
  icons: Node,
  outgoingPaymentMapper?: OutgoingPaymentMapper,
  paymentMethodForm?: Node,
  paymentMethodInstructions?: Node,
|}

export function findPaymentMethodByCode(paymentMethodCode: string, countryCode: CountryCode): ?PaymentMethod {
  const country: ?Country = SUPPORTED_COUNTRIES.find(country => country.code === countryCode);
  if (!country) return undefined;

  return findPaymentMethodInCountry(paymentMethodCode, country);
}

export function findPaymentMethodInCountry(paymentMethodCode: string, country: Country): ?PaymentMethod {
  return country?.supportedPaymentMethods?.find(paymentMethod => paymentMethod.code === paymentMethodCode);
}
